import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'scheduleFieldDisabled'
})
export class ScheduleFieldDisabledPipe implements PipeTransform {
  transform(
    columnName: string,
    originalFormData: any,
    additionalColumns: any
  ): any {
    // decides whether a schedule field should be disabled
    switch (columnName) {
      case 'barrier':
        if (
          originalFormData['barrierType'] === 'None' ||
          !originalFormData['barrierType']
        ) {
          return true;
        }
        return false;
      case 'secondBarrier':
        if (
          originalFormData['secondBarrierType'] === 'None' ||
          !originalFormData['secondBarrierType']
        ) {
          return true;
        }
        return false;
      case 'lowerBarrier':
        if (
          !originalFormData['lowerBarrierType'] ||
          originalFormData['lowerBarrierType'] === 'None' ||
          (!originalFormData['lowerBarrierObservationType'] &&
            originalFormData['lowerBarrierObservationType'] !== undefined) ||
          (originalFormData['lowerBarrierObservationType'] &&
            (originalFormData['lowerBarrierObservationType'] === 'None' ||
              originalFormData['lowerBarrierObservationType'] === 'American'))
        ) {
          return true;
        }
        return false;
      case 'upperBarrier':
        if (
          !originalFormData['upperBarrierType'] ||
          originalFormData['upperBarrierType'] === 'None' ||
          (!originalFormData['upperBarrierObservationType'] &&
            originalFormData['upperBarrierObservationType'] !== undefined) ||
          (originalFormData['upperBarrierObservationType'] &&
            (originalFormData['upperBarrierObservationType'] === 'None' ||
              originalFormData['upperBarrierObservationType'] === 'American'))
        ) {
          return true;
        }
        return false;
    }
    return !!additionalColumns.filter(x => x.shortName === columnName).length;
  }
}
